import { render, staticRenderFns } from "./LensCommentsView.vue?vue&type=template&id=4f54ffc4&scoped=true"
import script from "./LensCommentsView.vue?vue&type=script&lang=js"
export * from "./LensCommentsView.vue?vue&type=script&lang=js"
import style0 from "./LensCommentsView.vue?vue&type=style&index=0&id=4f54ffc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54ffc4",
  null
  
)

export default component.exports